export default {
  'dashboard': {
    'objetives': {
      'digitalization': {
        'title': 'Economic results'
      },
      'economic': {
        'title': 'Digital services'
      },
      'efficiency': {
        'title': 'Safety & Environment'
      },
      'people': {
        'title': 'Human Resources'
      },
      'security': {
        'title': 'Production'
      }
    }
  },
  'dashboardNav': {
    'steeringCommittee': 'Steering Committee',
    'departments': 'Departaments',
    'sales': 'Sales',
    'operations': 'Operations',
    'manufacturing': 'Manufacturing',
    'logistics': 'Logistics',
    'financial': 'Financial',
    'purchases': 'Purchases',
    'safetyQualityAndEnvironment': 'Safety, Quality & Environment',
    'r_d': 'R&D',
    'humanResources': 'Human Resources',
    'processes': 'Processes',
    'projectManagement': 'Project Management',
    'productDevelopment': 'Product Development'
  },
  'explore': {
    'title': 'Select the exploration type'
  },
  'explorer': {
    'from': 'Data from',
    'sampledVariables': 'Sampled variables:',
    'breadcrumbParent': 'Explorer: Linear timeline',
    'breadcrumbParentOldExplorer': 'Explorer: Correlation', // TODO refactor to a generic breadcrumb with the new explorer
    'breadcrumbMultipleCorrelation': 'Explorer: Benchmark correlation',
    'parameterSelection': 'Parameter selection',
    'datesSelection': 'Select time range',
    'categories': 'Categories',
    'none': 'None',
    'checkedIntensity': 'Intensity',
    'checkedIndividualCategory': 'Individual category',
    'checkedGlobalCategory': 'Global category',
    'addVariables': 'Add variables',
    'selectionVariables': 'Select variables',
    'selectionMultipleVariables': 'Select multiple variables',
    'reset': 'Reset values',
    'rangeErrorMin': 'Tiene que ser menor que el máximo',
    'rangeErrorMax': 'Tiene que ser mayor que el mínimo',
    'max': 'Maximum value',
    'min': 'Minimum value',
    'optionsDropdown': 'Visualisation options',
    'axisX': 'X axis',
    'axisY': 'Y axis',
    'multipleCorrelation': 'Benchmark correlation',
    'intensity': 'Intensity',
    'correlationSelectTitle': 'Select correlation to export',
    'correlationOptions': {
      'fixedAxes': 'Adjust x and y axis',
      'toEvolution': 'Change to evolution',
      'divergent': 'Switch to divergent colors',
      'sequential': 'Switch to sequential colors',
      'exchangeAxes': 'Exchange axes'
    },
    'evolutionOptions': {
      'fixedAxes': 'Adjust y axis',
      'singleAxis': 'Single axis',
      'toCorrelation': 'Change to correlation',
      'gridVisibleChecked': 'Grid',
      'showPoints': 'Display points'
    },
    'defaultRangeDate': {
      'today': 'Today',
      'yesterday': 'Yesterday',
      'last7Days': 'Last 7 days',
      'last30Days': 'Last 30 days',
      'thisMonth': 'This month',
      'lastMonth': 'Last month',
      'custom': 'Custom'
    },
    'menu': {
      'clearSelection': 'Clear selection',
      'aggregateFunctionDescription': 'Choose the aggregation function average, sum, maximum and minimum per each variable.',
      'aggregateFunctionTitle': 'Aggregation function',
      'evolution': {
        'description': 'Line graph',
        'info': 'Compare variables against a time period.',
        'label': 'Linear timeline',
        'uniqueAxis': 'Unique axis'
      },
      'explore': 'Explore',
      'intensity': 'Based on a third variable , the graph provides additional information providing added intensity.',
      'loadVariablesDescription': 'Search, select and load available variables in the graph to compare them against each other.',
      'loadVariablesLabel': 'Add variables',
      'multiple': {
        'chart1': 'Graph 1',
        'chart2': 'Graph 2',
        'chart3': 'Graph 3',
        'chart4': 'Graph 4',
        'description': 'Scatter plot',
        'info': 'Search up to nine variables and display data in four graphs, in addition to the ninth intensity variable in each of the four graphs, it shows the correlation between three variables in each of the four graphs.',
        'intensidad': 'Intensity',
        'label': 'Multiple correlation',
        'xAxis': 'X-axis',
        'yAxis': 'Y-axis'
      },
      'relations': {
        'description': 'Scatter plot',
        'info': 'Compare two variables in a scatter plot to be able to find quantitative correlations between two variables. It also adds information to the data providing an added intensity based on a third variable.',
        'intensity': 'Intensity',
        'label': 'Simple correlation'
      },
      'tagVariable': 'tag variable...',
      'title': '¿What do you want to display?'
    },
    'selectorModal': {
      'header': 'Add variable',
      'function': 'Aggregation function',
      'add': 'Add',
      'addVariablePlaceholder': 'Select variables',
      'modalMandatoryFieldsNotification': 'Select variables'
    },
    'queryModal': {
      'title': 'Save query',
      'queryName': 'Query name',
      'checkboxLabel': 'Fixed date range',
      'tooltipTitle': 'Info',
      'tooltipDescription': 'If this option is selected, start date and end date are included in the query',
      'queryNameError': 'You should enter a query name'
    },
    'showMenuButtonLabel': 'Explorer Menu',
    'title': 'Explorer',
    'to': 'to',
    'urlCopy': 'The URL has been copied',
    'urlSave': 'The name of the query',
    'copyUrlError': 'No query has been made. Press on \'EXPLORE\'',
    'noVariableSelected': 'Select at least one variable before exploring data',
    'intensityVariableRequired': 'Select intensity variable to show the plot with colors',
    'selectUnlessFirstTwoVariables': 'Select at least the first two variables before exploring data',
    'selectUnlessTwoVariables': 'Select at least two variables of a chart before exploring data',
    'selectMultiplePairs': 'Select the pairs of variables (4 max)'
  },
  'aggregateVariable': {
    'aggregateVariable': 'Aggregate variable',
    'title': 'Aggregate variables',
    'addAggregateVariable': 'Add aggregate variable',
    'editAggregateVariable': 'Edit aggregate variable',
    'creationDate': 'Creation date',
    'createdBy': 'Owner',
    'algorithm': 'Formula',
    'variable': 'Variable',
    'constant': 'Constant',
    'operator': 'Operator',
    'name': 'Name',
    'unit': 'Unit',
    'successCreation': 'Variable {name} created',
    'errorCreation': 'An error occurred creating the variable {name}',
    'successUpdate': 'Variable {name} updated',
    'errorUpdate': 'An error occurred updating the variable {name}',
    'successDelete': 'Variable {name} deleted',
    'errorDelete': 'An error occurred deleting the variable {name}',
    'deleteModalTitle': 'Delete aggregate variable',
    'deleteModalMessage': 'Are you sure you want to delete the aggregate variable?',
    'deleteDependenciesMessage': 'The variable could not be deleted because it has the following dependencies:',
    'variableDependencies': 'Variables',
    'ruleDependencies': 'Rules',
    'constantVariables': 'Operations between constants and variables',
    'gradualVariables': 'Over time gradual variable increment',
    'gradualIncrement': 'Increment of "{name}" in {timeGap}',
    'metricalVariables': 'Plant metrics',
    'calculateHistoricalData': 'Calculate historical data'
  },
  'aggregateGradualVariable': {
    'selectVariable': 'Select Variable',
    'timeGap': 'Time range for the gradual calculation',
    'oneMinute': '1 Minute',
    'oneHour': '1 Hour',
    'oneDay': '1 Day',
    'oneMonth': '1 Month',
    'aggregateVariable': 'Aggregate variable',
    'timeGapTitle': 'Time range',
    'editAggregateGradualVariable': 'Edit aggregate gradual variable',
    'addAggregateGradualVariable': 'Add aggregate gradual variable',
    'calculateHistoricalData': 'Calculate historical data'
  },
  'aggregateMetricalVariable': {
    'addAggregateMetricalVariable': 'Add plant metric',
    'editAggregateMetricalVariable': 'Edit plant metric',
    'metrical': 'Metrical',
    'metrics': {
      'mean': 'Arithmetic mean',
      'median': 'Median',
      'maximum': 'Maximum',
      'minimum': 'Minimum',
      'standardDeviation': 'Standard Deviation',
      'q1': 'Q1',
      'q3': 'Q3'
    },
    'calculateHistoricalData': 'Calculate historical data'
  },
  'rawVariable': {
    'title': 'Native variables',
    'editRawVariable': 'Edit native variable',
    'reference': 'Reference'
  },
  'variables': {
    'variableSelector': 'Variable selector',
    'taxonomy': 'Variables taxonomy',
    'tags': 'Tags',
    'variables': 'Variables',
    'add': 'Add',
    'addTag': 'Add tag',
    'addChildTag': 'Add tag under',
    'reference': 'Reference',
    'name': 'Name',
    'unit': 'Unit',
    'deleteModal': 'The tag is used by some variable. Do you want to delete it anyway?',
    'updateModal': 'Some tag that is used by at least one variable is now a category of tags. These tags will be removed from the variables that contained them. Do you want to update anyway?',
    'editionTitle': 'Group Tag Assignment',
    'selection': 'Select / Unselect all variables',
    'filter': 'Filter by tags',
    'repeatedTags': 'Repeated tags: {tags}',
    'multipleTagsExample': 'tag1, tag2, tag3',
    'andXMore': 'and {count} more'
  },
  'filter': {
    'filterModeTitleMobile': 'Period',
    'cancel': 'cancel',
    'hour': 'Hour',
    'minute': 'Minutes',
    'monthly': 'Monthly',
    'second': 'Seconds',
    'submit': 'confirm',
    'today': 'Today is',
    'yearly': 'Annual'
  },
  'login': {
    'contact': 'Please contact <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a> if you have any problem with your username or password.',
    'resetPassword': 'With verified mail you can reset the password <a href="/password/reset">here</a>',
    'enter': 'Log in',
    'alreadyHaveAnAccount': 'You already have an account?',
    'help': "Can't you login?",
    'password': 'Password',
    'subtitle': 'Please login with your username and password.',
    'title': 'Welcome to X-Dwall',
    'user': 'User',
    'userErrorMessage': 'User not found',
    'userLabel': 'User',
    'userPlaceholder': 'Enter your username here',
    'passwordPlaceholder': 'Enter your password here',
    'passwordErrorMessage': 'Wrong password'
  },
  'resetPassword': {
    'userLabel': 'User',
    'userPlaceholder': 'Enter your username here',
    'user': 'User',
    'subtitle': 'Please login with your username and we will send you an email.',
    'title': 'Reset password',
    'send': 'Send'
  },
  'emailVerification': {
    'noParam': 'No parameter in url',
    'error': 'Oops! Something went wrong!',
    'success': 'Ok',
    'title': 'Verifying email',
    'sendEmail': 'Sent mail for verification process',
    'errorSendEmail': 'Error verification process',
    'duplicatedEmail': 'This email is already in use'
  },
  'signin': {
    'title': 'Sign in',
    'btn': 'Create account',
    'noAccountCreate': 'Create account',
    'email': 'Email',
    'notValidEmail': 'Invalid email',
    'duplicatedEmail': 'Email already exists',
    'success': 'Welcome :)',
    'error': 'Opps :(',
    'termsAndConditions': 'Terms and Conditions of Use',
    'advice': 'By clicking Register, you accept the <a href="/legal" target="_blank">Terms and Conditions of Use</a>.'
  },
  'management': {
    'filterModeTitle': 'Information',
    'goal': 'Goal',
    'goals': 'Goals',
    'managementComite': 'Steerinsigning Committee',
    'managementPanel': 'Dashboard',
    'evolution': 'Evolution',
    'objetives': {
      'digitalization': {
        'description': 'Initiate activity diversification.<br> Deploy digitalization strategy.',
        'title': 'Digitalization and New Businesses'
      },
      'economic': {
        'description': 'Meet the current established oil refining.<br>Meet the established annual cost plan.',
        'title': 'Financial results'
      },
      'efficiency': {
        'description': 'Improve energy management. Consumption and regulation.<br>Improve availability and units consumption.',
        'title': 'Efficiency'
      },
      'people': {
        'description': 'Improve company´s reputation.<br>Increase the commitment of people with Petronor´s project.',
        'title': 'People and sustainability'
      },
      'security': {
        'description': 'Improve the security of people and facilities.<br>Minimize the impact of our activity.',
        'title': 'Security and Environment'
      }
    },
    'secondaryMenuBtn': 'Management Dashboards'
  },
  'market': {
    'filterTitleLeft': 'Average of',
    'filterTitleRight': 'Difference with respect to',
    'filterModeTitle': 'Information',
    'evolution': 'Evolution',
    'objetivesTitle': 'Objetives',
    'crude': 'Crude',
    'product': 'Product',
    'margin': 'Margin',
    'marketTitle': 'Market',
    'strategicLines': 'Strategic lines',
    'strategy': {
      'first': {
        'objetives': {
          'first': 'Improve the security of people and facilities.',
          'fourth': 'Improve the reputation of the company.',
          'second': 'Minimize the impact of our activity.',
          'third': 'Improve the energy management. Consumption and regulations.'
        },
        'title': 'Minimize the impact of our activity and be the development force of our environment.'
      },
      'fourth': {
        'objetives': {
          'first': 'Initiate the activity diversification.',
          'second': 'Deploy digitalization strategy.'
        },
        'title': 'Innovation management: open innovation and profitable.'
      },
      'second': {
        'objetives': {
          'first': 'Reach the established oil refining margin.',
          'fourth': 'Improve the availability and utilisation of the units.',
          'second': 'Meet the established annual cost plan.',
          'third': 'Improve the energy management. Consumptions and reductions.'
        },
        'title': 'Maximize the eficiency sustainably.'
      },
      'third': {
        'objetives': {
          'first': 'Increase people´s commitment with Petronor´s project.',
          'second': 'Deploy digitalisation strategy.'
        },
        'title': 'Culture and management model transformation'
      }
    }
  },
  'currentStatus': {
    'events': 'Events'
  },
  'menu': {
    'dashboard': 'Dashboard',
    'explorer': 'Explorer',
    'correlation': 'Correlation',
    'logout': 'Logout',
    'management': 'Management',
    'market': 'Market',
    'currentStatus': 'Current status',
    'workspace': 'Workspace',
    'process': 'Process',
    'queries': 'Queries',
    'taxonomy': 'Taxonomy',
    'aggregateVariables': 'Aggregate Variables',
    'settings': 'Settings',
    'spanish': 'Spanish',
    'title': 'Menu',
    'masterLubricationPressure': 'Master lubrication pressure Lathe 3078',
    'levelsAndRhythms': 'Levels and rhythms',
    'userManual': 'Help',
    'styleguide': 'Styleguide',
    'csvFoodCompositionIngest': 'CSV food uploader',
    'foodManager': 'Manage foods',
    'csvIngest': 'CSV uploader',
    'gpxIngest': 'GPX uploader',
    'strava': 'Strava',
    'fitbit': 'Fitbit',
    'googleFit': 'Google Fit',
    'oura': 'Oura',
    'withings': 'Withings',
    'garmin': 'Garmin',
    'integrate': 'Integration Panel',
    'licenseManagement': 'License management',
    'glucoseUploader': 'Upload Librelink',
    'superSapiens': 'Upload Supersapiens',
    'glucoseError': 'Error, file not compatible, please upload valid CSV',
    'glucoseGood': 'Glucose uploaded successfully',
    'glucoseUploaderTittle': 'Upload glucose data to',
    'glucoseEntry': 'glucose.entry',
    'glucoseEntryTittle': 'Upload Glucose Data',
    'glucoseFile': 'Please select a CSV file',
    'knowMore': 'Know more'
  },
  'queries': {
    'filterTitle': 'Last query',
    'movement': 'Tanks in movement',
    'nav': 'Levels and rythyms',
    'secondaryMenuBtn': 'Queries menu',
    'title': 'Levels and rythyms query',
    'update': 'Update query',
    'createQuery': 'Create query'
  },
  'topbarSettings': {
    'copy': 'Copy URL',
    'download': 'Download',
    'send': 'Send by e-mail',
    'print': 'Print',
    'downloadCSV': 'Download CSV'
  },
  'rule': {
    'rule': 'Rule',
    'singleRule': 'Single rule',
    'groupalRule': 'Groupal rule',
    'newRule': 'New rule',
    'addGroupalRule': 'Add groupal rule',
    'editGroupalRule': 'Edit groupal rule',
    'title': 'Rules',
    'name': 'Name',
    'type': 'Type',
    'single': 'Single',
    'groupal': 'Groupal',
    'creationDate': 'Creation date',
    'createdBy': 'Owner',
    'enabled': 'Enabled',
    'successDelete': 'Rule {name} deleted',
    'errorDelete': 'An error occurred deleting the rule {name}',
    'successCreation': 'Rule {name} created successfully',
    'errorCreation': 'An error occurred creating the rule',
    'successUpdate': 'Rule {name} updated successfully',
    'errorUpdate': 'An error occurred updating the rule',
    'constant': 'Constant',
    'variable': 'Variable',
    'addRule': 'Add rule',
    'editRule': 'Edit rule',
    'operator': 'Operator',
    'deleteModalTitle': 'Delete rule',
    'deleteModalMessage': 'Are you sure you want to delete the rule?',
    'emails': 'Send notifications by e-mail to these addresses (separated by commas)',
    'emailFieldErrorMessage': 'Enter valid email addresses separated by commas',
    'sendAlertsCheckbox': 'Notify events by e-mail',
    'enabledCheckbox': 'Enable the rule on the platform'
  },
  'commons': {
    'ok': 'OK',
    'yes': 'Yes',
    'no': 'No',
    'accept': 'Accept',
    'cancel': 'Cancel',
    'close': 'Close',
    'delete': 'Delete',
    'update': 'Update',
    'save': 'Save',
    'saving': 'Saving…',
    'confirm': 'Confirm',
    'mandatoryFieldMessage': 'Mandatory field',
    'back': 'Go back',
    'add': 'Add',
    'remove': 'Remove',
    'browserNotSupported': 'Browser not supported',
    'browserSuggestion': 'Download <a href="https://www.google.com/chrome/">Google Chrome</a> to enjoy all features.'
  },
  'personalArea': {
    'profile': 'My profile',
    'email': 'Email',
    'rolesAndPermissions': 'Roles and permissions',
    'validateEmail': 'Validate',
    'updatePassword': 'Update password'
  },
  'events': {
    'title': 'Events',
    'name': 'Name',
    'activationCount': 'Activation count',
    'firstActivation': 'First activation date',
    'lastActivation': 'Last activation date'
  },
  'query': {
    'title': 'Queries',
    'name': 'Name',
    'path': 'Link',
    'owner': 'Owner',
    'deleteModalMessage': 'Are you sure you want to delete the query?',
    'successDelete': 'Query {name} deleted',
    'errorDelete': 'An error occurred deleting the query {name}',
    'star': 'Favourite',
    'editQuery': 'Edit query',
    'successUpdate': 'Query {name} updated successfully',
    'errorUpdate': 'An error occurred updating the query {name}',
    'share': 'Permissions'
  },
  'variableManagement': {
    'title': 'Variable management',
    'origin': 'Origin',
    'type': 'Type',
    'raw': 'Raw',
    'aggregate': 'Aggregate',
    'categoricalVariables': 'Categorical variable groups',
    'editVariable': 'Edit variable',
    'reference': 'Reference',
    'quantitative': 'Quantitative',
    'categorical': 'Categorical',
    'createCategoricalVariable': 'Create categorical variable group',
    'updateCategoricalVariable': 'Edit categorical variable group',
    'successUpdate': 'Categorical variable group {name} updated successfully',
    'errorUpdate': 'An error occurred updating the categorical variable group {name}',
    'assignCategories': 'Assign categories',
    'value': 'Value',
    'groupName': 'Group name',
    'addCategory': 'Add category',
    'name': 'Name',
    'owner': 'Owner',
    'categories': 'Categories',
    'deleteModalMessage': 'Are you sure you want to delete the categorical variable group?',
    'successDelete': 'Categorical variable group {name} deleted',
    'errorDelete': 'An error occurred deleting the categorical variable group {name}',
    'successCreate': 'Categorical variable group {name} created',
    'errorCreate': 'An error occurred creating the categorical variable group {name}',
    'category': 'Category',
    'withoutCategory': 'No category'
  },
  'permission': {
    'titleRule': 'Permissions of the rule',
    'titleAggregateVariable': 'Permissions of the aggregate variable',
    'titleQuery': 'Permissions of the query',
    'usersTitle': 'Users',
    'name': 'Name',
    'permissions': 'Permissions',
    'groupsTitle': 'Groups',
    'read': 'Read',
    'edit': 'Edit',
    'share': 'Share',
    'addUserGroup': 'Add permission to user or group',
    'deleteModalMessage': 'Are you sure you want to delete the permissions assigned to the {item}?',
    'errorNoPermissionSelected': 'Select an user or group',
    'selectorModal': {
      'header': 'Add permission to an user or group',
      'selectTarget': 'Select an user or group'
    },
    'overlapTitle': 'The following users had less permissions than the assigned to this group:',
    'overlapFooter': 'Now they will have the same permissions as the group.',
    'user': 'user',
    'group': 'group',
    'successAddPermission': 'Permission created successfully',
    'errorAddPermission': 'An error occurred creating the permission',
    'successRemovePermission': 'Permission removed successfully',
    'errorRemovePermission': 'An error occurred removing the permission'
  },
  'settings': {
    'title': 'Settings',
    'users': 'Users',
    'groups': 'Groups and permissions',
    'permission': 'Users\' data reading'
  },
  'group': {
    'title': 'Groups',
    'name': 'Name',
    'add': 'Create group',
    'successUpdate': 'Group {name} updated successfully',
    'deleteModalMessage': 'Are you sure you want to delete the group?',
    'successDelete': 'Group {name} deleted',
    'errorDelete': 'An error occurred deleting the group {name}',
    'new': 'Create group',
    'edit': 'Edit group',
    'users': 'Users of {name}',
    'addUser': 'Add user',
    'successCreation': 'Group {name} created successfully',
    'errorCreation': 'An error occurred creating the group',
    'errorUpdate': 'An error occurred updating the group {name}',
    'removeUser': 'Remove user {name}',
    'groupAlreadyExists': 'Group already exists',
    'addUserModal': {
      'header': 'Users',
      'userNotSelectedError': 'Select a user',
      'user': 'User'
    },
    'permissions': {
      'title': '{name}\'s permissions',
      'rulesAndEvents': 'Rules and events',
      'aggregateVariable': 'Aggregate variables',
      'board': 'Board',
      'multiboard': 'Multiboard',
      'summary': 'Summary',
      'glucose': 'Glucose',
      'integration': 'Integration',
      'nutritionalPlan': 'Nutritional plan',
      'description': {
        'dashboard': '"Dashboard" displays the main KPIs of the company, showing the degree of fulfillment of the objectives. The KPIs are grouped within the company verticals (Example: Security, Human Resources, Production, etc.)',
        'market': '“Market” displays the main market KPIs of the sector of the company. ',
        'process': '“Processes” holds the screens that optimize the operating ratios of the company, using advanced analytics solutions.',
        'explorer': '“Explorer” boosts the knowledge generation helping the user to analyse the available data of the plant. There are three types of visualisations:  “Linear timeline” (line graph), “Simple correlation” (scatter plot) y “Multiple correlation” (4 scatter plots at the same time).',
        'levelsAndRhythms': '“Levels and rythms” shows the status of the tanks in real time, in order to optimize the decision-making process in the operation.',
        'queries': '“Queries” allows direct access to queries from the “Explorer” that have been previously saved.',
        'taxonomy': '“Taxonomy” allows to group variables by using tags.',
        'rules': '“Events” is directly related to “Rules”. “Events” panel shows the list of events that have occurred as a result of non-compliance with a rule defined in the platform. The management and generation of the rules is done through "Rules" panel.',
        'board': '“Board” displays user\'s main information in a linear timeline graph.',
        'multiboard': '“Multiboard” allows to display multiple users\' general information.',
        'integration': 'Integrations allow users to obtain information from external resources.',
        'summary': '“Summary” shows user\'s main data aggregated displayed in different types of graphs.',
        'nutritionalPlan': 'The “Nutritional Plan” allows the user to visualize the plan prepared by it\'s nutritionist.',
        'glucose': 'The “Glucose” allows the user to save and read glucose related data.',
        'aggregateVariables': '“Aggregate variables” allows to manage and generate aggregate variables. These aggregate variables are available within the browser.',
        'masterLubricationPressure': '“Master lubrication pressure” displays the lubrication pressure curve, showing the pattern of the curve and its evolution within the selected time period.'
      }
    },
    'successUserAdded': 'User added successfully',
    'errorUserAdded': 'An error occurred adding the user',
    'successUserRemoved': 'User removed successfully',
    'errorUserRemoved': 'An error occurred removing the user'
  },
  'user': {
    'title': 'Users',
    'name': 'Name',
    'email': 'Email',
    'usernameLabel': 'Username (in lower case and without spaces)',
    'surnameLabel': 'Surname',
    'nameLabel': 'Name',
    'admin': 'Administrator',
    'xugarkid': 'Xugarkid',
    'nutri': 'Nutri',
    'prescriptor': 'Prescriptor',
    'addFormTitle': 'Add user',
    'successDelete': 'User {name} deleted',
    'errorDelete': 'An error occurred deleting the user {name}',
    'successUpdate': 'User {name} updated successfully',
    'editFormTitle': 'Edit user',
    'new': 'Add user',
    'password': 'Password',
    'passwordRepeat': 'Confirm password',
    'deleteModalMessage': 'Delete user',
    'passwordShouldBeEqual': 'The password is different',
    'successCreation': 'User {name} created successfully',
    'errorCreation': 'An error occurred creating the user',
    'errorUpdate': 'An error occurred updating the user {name}',
    'passwordFormatMessage': 'Password must be at least 6 characters long and contain mixture of letters and numbers.',
    'userAlreadyExists': 'User already exists',
    'invalidUsername': 'Username can\'t contain special characters',
    'status': 'Status',
    'enabled': 'enabled',
    'disabled': 'disabled'
  },
  'masterLubricationPressure': {
    'title': 'Master lubrication pressure Lathe 3078',
    'from': 'From',
    'to': 'To',
    'update': 'analise',
    'patternName': 'Pattern',
    'labelX': 'Data points',
    'labelY': 'Bar',
    'tooltipTitle': ' (Minimum and maximum values)'
  },
  'userProfile': {
    'title': 'User profile',
    'oldPassword': 'Current password',
    'newPassword': 'New password',
    'newPasswordRepeat': 'Repeat new password',
    'passwordWrong': 'Wrong password'
  },
  'dashboardDetail': {
    'next': 'next',
    'prev': 'previous'
  },
  'backoffice': {
    'cacheManagement': 'Caché management',
    'cache': {
      'key': 'Key',
      'value': 'Value stored on cache',
      'time': 'Cache date',
      'deleteModalMessage': 'Delete cached information',
      'successDelete': 'Success deleting cache',
      'errorDelete': 'Error deleting cache'
    }
  },
  'permissionAssignment': {
    'title': 'Permission assignment',
    'save': {
      'success': 'The list of permissions for {name} has been updated successfully',
      'errorForUser': 'An error occurred updating permissions of {name}',
      'error': 'An error occurred updating permissions'
    }
  },
  'form': {
    'required': 'Required field'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/en_GB/translations.js